import type { ChatMessage } from "./types.js";

export const ANNOUNCEMENT_TTL = 3_600_000;
export function announcementFeed(messages: readonly ChatMessage[], now: number, excluded: ReadonlySet<string> = new Set()): ChatMessage[] {
  const unique = new Map<string, ChatMessage>();
  for (const message of messages) {
    if (message.channel !== "system" || !message.system || message.deleted || excluded.has(message.id) || message.createdAt > now || now - message.createdAt >= ANNOUNCEMENT_TTL) continue;
    unique.set(message.id, message);
  }
  return [...unique.values()].sort((a, b) => b.createdAt - a.createdAt || b.id.localeCompare(a.id)).slice(0, 20);
}
